import { FunctionComponent, useContext } from "react";
import { Option } from "space-monad";
import styled from "styled-components";
import {
  CenteredFlex,
  columnFlex,
  Flex,
  Grid,
} from "../../../../../components/layout";
import { device } from "../../../../../styles/media";
import { formatEther } from "../../../../../utils/utils";
import { StakeContext } from "../../context";

interface IFormProps { }

const Amount = styled.h3`
  font-size: 1.4em;
  font-weight: 700;
  text-align: center;

  @media ${device.tablet} {
    margin-top: 2em;
  }
`;

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  padding: 0 2em;
  max-width: 100%;

  @media ${device.tablet} {
    width: 30em;
    height: 20em;
  }
`;

const StyledGrid = styled(Grid)`
  & > div:nth-child(n) {
    text-align: left;
  }
  & > div:nth-child(2n) {
    text-align: right;
  }
`;

const Form: FunctionComponent<IFormProps> = () => {
  const { currentContract } = useContext(StakeContext);

  return (
    <Wrapper>
      <h3>Are you sure you want to unstake?</h3>
      {currentContract
        .map((x) => x.walletInfo)
        .fold(
          () => null,
          ({ balance, rewards }) => (
            <Amount>
              <StyledGrid col-xs={2}>
                <div>Locked Balance:</div>
                <div>$SKRT {formatEther(balance)}</div>
                <div>Rewards:</div>
                <div>$SKRT {formatEther(rewards.effective)}</div>
              </StyledGrid>
            </Amount>
          )
        )}
    </Wrapper>
  );
};

export default Form;
